import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

const SmoothScroll = ({ children, className = "" }) => {
  useEffect(() => {
    // Create smooth scroll effect
    const smoothScroll = ScrollTrigger.create({
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      onUpdate: () => {
        // Add momentum to scroll
        gsap.to(window, {
          duration: 0.1,
          ease: "power2.out",
        });
      },
    });

    // Add smooth scroll behavior to all anchor links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          gsap.to(window, {
            duration: 1.5,
            scrollTo: {
              y: targetElement,
              offsetY: 80,
            },
            ease: "power3.inOut",
          });
        }
      });
    });

    // Cleanup
    return () => {
      smoothScroll.kill();
      anchorLinks.forEach((link) => {
        link.removeEventListener("click", () => {});
      });
    };
  }, []);

  return <div className={className}>{children}</div>;
};

export default SmoothScroll;
